import { render, staticRenderFns } from "./TaxTransactions.vue?vue&type=template&id=040a98d8&"
import script from "./TaxTransactions.vue?vue&type=script&lang=js&"
export * from "./TaxTransactions.vue?vue&type=script&lang=js&"
import style0 from "./TaxTransactions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports